import React from "react"
import styled from "styled-components"
import { P, Title } from "@motorata/base-ui.components.atoms.typography";
import { blockPadding, blockStyles } from "@motorata/base-ui.components.atoms._atoms";
import List from "@motorata/base-ui.components.molecules.list";
import { NextImage } from "../common/Image";

const RentSection = () => {
  return (
    <Wrapper className="background">
      <Content>
        <ImageWrapper>
          <NextImage
            priority={true}
            fill
            src="/images/rent.png"
            alt="Grafika wynajmu krótkoterminowego samochodu"
          />
        </ImageWrapper>
        <TextWrapper>
          <Title type="secondary" label="Samochody przedkontraktowe" elementType="label">
            Zbyt długi czas oczekiwania na samochód?
          </Title>
          <P small>
            Posiadamy własną flote samochodów przedkontraktowych, które możesz wynająć w momencie
            zbyt długiego oczekiwania na Twój wymarzony samochód. Posiadamy wysokie wersje
            wyposażenia samochodów dostępnych od ręki, z których możesz korzystać elastycznie nawet
            kilkanaście miesięcy!
          </P>
          <List list={["Samochody klasy standard oraz premium", "Odbiór w całej Polsce"]} />
          {/*<Button margin="2rem 0 0">*/}
          {/*  Dowiedz się więcej*/}
          {/*</Button>*/}
        </TextWrapper>
      </Content>
    </Wrapper>
  )
}

export default RentSection

const TextWrapper = styled.div`
  ${blockPadding};
`

const ImageWrapper = styled.div`
  position: relative;
  
  img{
    object-fit: contain;
    object-position: bottom;
  }
  
  @media (max-width: 850px) {
    height: 400px;
  }

  &:before {
    content: "";
    display: block;
    position: absolute;
    width: 50%;
    right: 50%;
    top: 0;
    height: 100%;
    background: rgba(0, 0, 0, 0.2);
    clip-path: polygon(0 0, 50% 0, 100% 100%, 0% 100%);
    opacity: 0.2;

    @media (max-width: 850px) {
      height: 100%;
      width: 100vw;
      margin-left: calc((100vw - 100%) / -2);
      right: auto;
      left: 0;
      top: auto;
      bottom: 0;
      clip-path: polygon(0 0, 100% 50%, 100% 100%, 0% 100%);
    }
  }

  &:after {
    content: "";
    display: block;
    position: absolute;
    width: 100vw;
    right: 100%;
    top: 0;
    height: 100%;
    background: rgba(0, 0, 0, 0.2);
    opacity: 0.2;

    @media (max-width: 850px) {
      display: none;
    }
  }
`

const Content = styled.div`
  position: relative;
  display: grid;
  grid-template-columns: 1fr 1.75fr;
  grid-gap: ${({ theme }) => theme.space.M};

  @media (max-width: 1100px) {
    display: flex;
    flex-direction: column-reverse;
    grid-gap: 0;
  }
`

const Wrapper = styled.div`
  ${blockStyles};

  margin-bottom: 0;
  margin-top: 0;
  max-width: 1200px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  &:before {
    opacity: 0.5;
  }
`
